import Link from 'next/link';
import type { ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';
import { Typography } from '../../ui';
import { useTranslation } from '../../../../lib/i18n';
import { useBasePath } from '../../../../lib/use-base-path';
import { useGenericBi } from '../../../../lib/use-generic-bi';
import { KnowledgeIcon } from '../DestinationCard';
import { YOUR_AGENTS_PAGE } from '../use-your-agents';
import styles from './MobileDestinationList.module.css';

// The management destinations at the foot of Your Agents (Figma `12155:98531`): what the team knows
// about you. Narrow lists them as full-width rows — glyph, title + blurb, chevron. Files moved up into
// the three-tile entry group at the top of the screen (`FilesSummaryCard entryRow`), so it is no longer
// a row here.

export function MobileDestinationList() {
  const { t } = useTranslation();
  return (
    <nav className={styles.list} aria-label={t('agents.destinations.label')}>
      <DestinationRow
        title={t('agents.destinations.knowledge.title')}
        subtitle={t('agents.destinations.knowledge.subtitle')}
        icon={<KnowledgeIcon />}
        href="/knowledge"
        button="knowledge"
      />
    </nav>
  );
}

function DestinationRow({
  title,
  subtitle,
  icon,
  href,
  button,
}: {
  title: string;
  subtitle: string;
  icon: ReactNode;
  href: string;
  button: string;
}) {
  const basePath = useBasePath();
  const { logPageClickBi } = useGenericBi();
  return (
    <Link
      className={styles.row}
      href={href}
      as={`${basePath}${href}`}
      onClick={() => logPageClickBi({ page_name: YOUR_AGENTS_PAGE, button_name: button })}
    >
      <span className={styles.glyph} aria-hidden>
        {icon}
      </span>
      <span className={styles.text}>
        <Typography variant="h4" color="strong" component="span">
          {title}
        </Typography>
        <Typography variant="p2" color="secondary" component="span">
          {subtitle}
        </Typography>
      </span>
      <span className={`${styles.chevron} dir-flip`} aria-hidden>
        <ChevronRight size={24} />
      </span>
    </Link>
  );
}
